import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { ServicePlan } from 'src/features/servicePlans/utils/types';

const RESOURCE = '/subscriptions/service-plan/:planId/deactivate/';

type MutationFnType = typeof mutationFn;

interface DTO {
    planId: string;
}

const mutationFn = ({ planId }: DTO): Promise<ServicePlan> => {
    return axios.post(formatResourcePath(RESOURCE, { planId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeactivateServicePlan };
